module.exports = __webpack_public_path__ + "img/maris-draw.189fd701.jpg";